import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        listStyle: 'none',
    },
    inlineRoot: {
        '& > *': {
            marginRight: spacing(3),
        },
        '& > *:last-child': {
            marginRight: 0,
        },
    },
    stackedItem: {
        borderBottom: `1px solid ${palette.divider}`,
        '&:last-child': {
            borderBottom: 0,
        },
    },
}));
export const DetailListContext = React.createContext({ isInline: false });
/**
 * Displays a collection of `DetailListItem`s. Most commonly these are
 * name/value data points.
 */
export const DetailList = props => {
    const classes = useStyles(props);
    const { children, layout = 'vertical', itemSize, ...rest } = props;
    const isInline = layout !== 'vertical';
    const isCentered = layout.includes('center');
    const isSpread = layout.includes('spread');
    let justifyContent = 'normal';
    if (isCentered) {
        justifyContent = 'center';
    }
    if (isSpread) {
        justifyContent = 'space-between';
    }
    return (React.createElement(DetailListContext.Provider, { value: {
            itemClassName: clsx({ [classes.stackedItem]: !isInline }),
            isInline,
            itemSize,
            centeredList: isCentered,
        } },
        React.createElement(Box, Object.assign({ component: "ul", m: 0, p: 0, className: clsx(classes.root, { [classes.inlineRoot]: isInline }), display: isInline ? 'flex' : 'block', justifyContent: justifyContent, flexWrap: isInline ? 'wrap' : undefined }, rest), children)));
};
export default DetailList;
//# sourceMappingURL=DetailList.js.map